<script>
  import { FirebaseApp, User, Doc, Collection } from "sveltefire";

  import SignIn from "./SignIn.svelte";
  import RoomSelect from "./RoomSelect.svelte";

  import firebase from "firebase/app";
  import "firebase/firestore";
  import "firebase/auth";
  import "firebase/performance";
  import "firebase/analytics";

  const firebaseConfig = {
    apiKey: "AIzaSyCTdSLjRJ_cSvyF5zrAUDf8rI4myQ76Ze8",
    authDomain: "eph-chat.firebaseapp.com",
    databaseURL: "https://eph-chat.firebaseio.com",
    projectId: "eph-chat",
    storageBucket: "eph-chat.appspot.com",
    messagingSenderId: "380776256019",
    appId: "1:380776256019:web:a6bb23624702e935a925e6"
  };

  firebase.initializeApp(firebaseConfig);
</script>

<main>

  <FirebaseApp {firebase}>

    <User let:user let:auth>

      <div slot="signed-out">
        <SignIn {auth} />
      </div>

      <RoomSelect {auth} {firebase} />

    </User>
  </FirebaseApp>

</main>
